import type { ResponseModel } from "services/ApiClient/responseModel";

export const GROUP_TYPES = ["team", "department", "location", "role"] as const;

export type GroupType = typeof GROUP_TYPES[number];

export interface GroupMember {
  id: number;
  uuid?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  workEmail: string;
  title?: string;
  avatarUrl?: string | null;
  deactivatedAt?: string | null;
}

export interface Group {
  id: number;
  name: string;
  groupType: GroupType;
  scimProvisioned: boolean;
  scimExternalId: string | null;
  scimLastSyncedAt: string | null;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface GroupDetail extends Group {
  users: GroupMember[];
}

export interface GroupsFilters {
  groupType?: GroupType;
  q?: string;
}

export type GroupsResponse = ResponseModel<Group[]>;
